'use strict';

import '../css/pages/index/header.scss';
import '../css/pages/index/introduction.scss';
import '../css/pages/index/movie-bar.scss';
import '../css/pages/index/people-in.scss';
import '../css/pages/index/caretaker.scss';
import '../css/pages/index/green-highlight.scss';
import '../css/pages/index/news.scss';

import { documentReady } from "./Shared/DocumentReady";
import MainSearchBar, { EVENT_SEARCH_SUBMIT } from "./MainSearchBar/MainSearchBar";
import SearchAddressAutocompleteField from "./SearchAddressAutocompleteField/SearchAddressAutocompleteField";
import SearchCatTagAutocompleteField from "./SearchCatTagAutocompleteField/SearchCatTagAutocompleteField";

documentReady(() => {
    window.super();
    const mainSearchBar = new MainSearchBar(
        new SearchAddressAutocompleteField(),
        new SearchCatTagAutocompleteField()
    );
    mainSearchBar.addEventListener(EVENT_SEARCH_SUBMIT, () => {
        mainSearchBar.elements.mainSearch.submit();
    });
});
